import SvgIcon from '@mui/material/SvgIcon'

const CardIcon = () => (
  <SvgIcon viewBox="0 0 22 22">
    <svg width="18" height="25" viewBox="0 0 18 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 6.22323L14.0244 1.04688V5.88927" fill="currentColor" />
      <path
        d="M1 6.22323L14.0244 1.04688V5.88927"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.03 6.22314H1V23.589H17.03V6.22314Z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8586 13.5706C13.8586 12.7357 13.5247 12.0678 12.8567 11.5668C12.3558 11.0659 11.8549 10.8989 11.187 10.8989C10.519 10.8989 9.85112 11.2329 9.35018 11.7338L9.01622 12.2348L8.68227 11.9008C8.01435 11.2329 7.34643 11.0659 6.67852 11.0659C6.17758 11.0659 5.50966 11.2329 5.00872 11.7338C4.50779 12.0678 4.17383 12.9027 4.17383 13.5706C4.17383 14.4055 4.34081 15.0734 5.00872 15.7413L9.01622 20.0827L13.0237 15.7413C13.6916 15.2404 13.8586 14.4055 13.8586 13.5706Z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
)

export default CardIcon
